import { Component, EventEmitter, Output,Input,OnInit } from '@angular/core';
// import { FileUploadService } from './../file-upload.service';
@Component({
  selector: 'app-filedraganddrop',
  standalone: true,  // Mark this as a standalone component
  templateUrl: './filedraganddrop.component.html',
  styleUrls: ['./filedraganddrop.component.css']
})
export class FiledraganddropComponent {
   @Output() filesUploaded: EventEmitter<FileList> = new EventEmitter<FileList>(); // Single output property
   @Output() errorMessage: EventEmitter<string> = new EventEmitter<string>(); // Single output property
   @Input() selectedFileExtention: string="";
   @Input() selectedHeader: string="";
   allowMultiple = false; // Set this to false for single file restriction
  // Handle files dropped in the drag-and-drop area
  
  onDrop(event: DragEvent) {
    event.preventDefault(); // Prevent the default action (e.g., opening the file)
    const files = event.dataTransfer?.files;  // Access the dropped files using the native DragEvent
   
    if (!files) return;
    if(this.selectedHeader=="Merge PDF")
    {
      this.allowMultiple=true;
    }
    if (!this.allowMultiple && files.length > 1) {
                this.errorMessage.emit('Only a single file is allowed.');
            return;
    }
    if (files && files.length > 0) {
      this.filesUploaded.emit(files); // Emit the files to the parent
    }
  }

  // Allow drop to happen by preventing the default action on dragover
  onDragOver(event: Event) {
    event.preventDefault();  // Allow drop action by preventing default
  }

  // Handle drag leave event (optional)
  onDragLeave(event: Event) {
    event.preventDefault();
  }

  // Handle files selected via the input
  onFileSelected(event: any) {
    const selectedFiles: FileList = event.target.files;
     if (selectedFiles && selectedFiles.length > 0) {
      this.filesUploaded.emit(selectedFiles); // Emit the files to the parent
    }
  }
  triggerFileSelect(fileInput: HTMLInputElement) {
    fileInput.click();
  }
  // Process files (e.g., upload or any other logic)
  handleFiles(files: FileList) {
    Array.from(files).forEach((file) => {
      console.log('File selected:', file.name);
      // Handle the file upload or any other logic here
    });
  }
}
